import Header18 from './Header18'
export default Header18
